export enum ItemWorkflowFilePrefixes {
	DEFAULT = "https://drive.google.com",
	GDOC = "https://docs.google.com/document/d/"
}
